export default __webpack_public_path__ + "static/media/deathTwo.4e924e64.svg";